import { createTheme } from '@mui/material/styles'

const darkItemColor = '#31353D'
const darkBgColor = '#282828'

const muiTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#9EC73E',
      contrastText: '#fff',
    },
    background: {
      paper: darkItemColor,
      default: darkBgColor,
    },
    text: {
      primary: '#fff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    action: {
      active: 'rgba(255, 255, 255, 0.56)',
    },
  },
  typography: {
    button: {
      fontWeight: 400,
      textTransform: 'none',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomColor: 'rgba(255, 255, 255, 0.12)',
        },
      },
    },
  },
})

export default muiTheme
